/* eslint-disable react-hooks/exhaustive-deps */

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

import styles from './UsersAccessRights.module.scss';
import Pagination from '../common/pagination/Pagination';
import { UsersAccessRightsListingResponseModel } from '../../models/users/UsersAccessRightsListingResponseModel';
import { UserCountryBrandRightsResponseModel } from '../../models/users/UsersCountryBrandRightsResponseModel';
import { nameof, stringToDataTableSortOrderType } from '../../shared/utility';
import { UsersAccessRightsFilters } from './filters/components/UsersAccessRightsFilters';
import AddAccessRights from './add/AddAccessRights';
import { useUsersAccessRights } from './hooks/useUsersAccessRights';
import { useUsersAccessRightsExpanded } from './hooks/useUsersAccessRightsExpandedRows';

const UsersAccessRights = (): JSX.Element => {
	const {
		users,
		control,
		setUsers,
		usersPaginationModel,
		loading,
		sortBy,
		order,
		filtersOptions,
		onPageChange,
		onSort,
		refetch,
		clearFilters
	} = useUsersAccessRights();

	const {
		expandedRows,
		onPageExpandedChange,
		onRowToggle,
		onRowExpand,
		deleteAccessRight
	} = useUsersAccessRightsExpanded(users, setUsers);

	const { rows, first, totalRecords } = usersPaginationModel;

	const onRenderDeleteButton = (
		cellData: UserCountryBrandRightsResponseModel
	) => {
		return (
			<i
				className={`${styles.deleteIcon} pi pi-trash`}
				onClick={() => deleteAccessRight(cellData.id, cellData.userId)}
			></i>
		);
	};

	const rowExpansionTemplate = (
		data: UsersAccessRightsListingResponseModel
	) => {
		return (
			<div className={styles.usersAccessRightsContainer}>
				<DataTable value={data.rights.models}>
					<Column
						sortable
						header='Country'
						field={nameof<UserCountryBrandRightsResponseModel>(
							'countryDescription'
						)}
					/>

					<Column
						sortable
						header='Brand'
						field={nameof<UserCountryBrandRightsResponseModel>(
							'brandDescription'
						)}
					/>

					<Column
						style={{ width: '3em' }}
						body={onRenderDeleteButton}
					/>
				</DataTable>

				<Pagination
					totalRecords={data.rights.total}
					rows={data.rights.totalPages}
					first={data.rights.first}
					onPageChange={(e) => onPageExpandedChange(e, data.id)}
				/>
			</div>
		);
	};

	return (
		<>
			<UsersAccessRightsFilters
				control={control}
				filtersOptions={filtersOptions}
				clearFilters={clearFilters}
				refetch={refetch}
			/>

			<DataTable
				value={users}
				responsiveLayout='scroll'
				sortField={sortBy}
				sortOrder={stringToDataTableSortOrderType(order)}
				onSort={onSort}
				expandedRows={expandedRows}
				onRowToggle={(e) => onRowToggle(e)}
				onRowExpand={(e) => onRowExpand(e)}
				rowExpansionTemplate={rowExpansionTemplate}
				loading={loading}
				dataKey='id'
			>
				<Column expander style={{ width: '3em' }} />

				<Column
					sortable
					header='Username'
					field={nameof<UsersAccessRightsListingResponseModel>(
						'username'
					)}
				/>

				<Column
					sortable
					header='First name'
					field={nameof<UsersAccessRightsListingResponseModel>(
						'firstname'
					)}
				/>

				<Column
					sortable
					header='Last name'
					field={nameof<UsersAccessRightsListingResponseModel>(
						'lastname'
					)}
				/>
			</DataTable>

			<Pagination
				totalRecords={totalRecords}
				rows={rows}
				first={first}
				onPageChange={onPageChange}
			/>
		</>
	);
};

export default UsersAccessRights;
